module.exports = __webpack_public_path__ + "static/media/cancel.afebb9f4.svg";